/**
 * @fileoverview POST handler for the "/companies/:company_id/custom_roles/duplicate_custom_role" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdCustomRolesDuplicateCustomRoleCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdCustomRolesDuplicateCustomRoleProps,
  CompaniesCompanyIdCustomRolesDuplicateCustomRoleResult,
} from "./types";

export const postCompaniesCompanyIdCustomRolesDuplicateCustomRole = reactQueryMutationAdapter(
  companiesCompanyIdCustomRolesDuplicateCustomRoleCacheKeys,
  (
    props: PostCompaniesCompanyIdCustomRolesDuplicateCustomRoleProps
  ): Promise<CompaniesCompanyIdCustomRolesDuplicateCustomRoleResult> => {
    return fetch(`/companies/${props.companyId}/custom_roles/duplicate_custom_role`, "POST", props.body);
  }
);
